module.exports = __webpack_public_path__ + "static/media/icon.00d6825c.png";